import React from 'react';
import TruthOrDare from '../Spinner/truth-or-dare/TruthOrDare';
import '../Spinner/Spinner.css';

const TruthOrDareWheel = () => {
  return(
    <div className="spinner-page">
      <TruthOrDare />
    </div>
  );
}
export default TruthOrDareWheel;